import { CitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { useCitationsContextService } from '@vivli/shared/features/citations/infrastructure/hook';
import { ReactNode } from 'react';
import { ICitation } from '@vivli/shared/features/citations/infrastructure/interface';

interface CitationsContextWrapperProps {
    children: ReactNode;
    objectId: string;
    doiStem?: string;
    isStudy: boolean;
    doUpdate: boolean;
    disclosureId?: string;
    externalCitations?: ICitation[];
}

/*object id  is the document id of the data request or study that "owns" the citation*/
export const CitationsContextWrapper = ({ children, ...props }: CitationsContextWrapperProps) => {
    const citationsContextService = useCitationsContextService({ ...props });

    return <CitationsContext.Provider value={citationsContextService}>{children}</CitationsContext.Provider>;
};
